var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-list',{staticClass:"ma-2",attrs:{"headers":_vm.listHeaders,"payload":_vm.listPayload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }